import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { LogService } from './log.service';
import { SentryService } from './sentry.service';
import { Observable } from 'rxjs/Observable';

export class AppConfig {
  private logglyTokenInternal: string = null;
  private socketEventsInternal: any = null;

  get logglyToken() {
    return this.logglyTokenInternal;
  }

  set logglyToken(token: string) {
    this.logglyTokenInternal = token;
  }

  get socketEvents() {
    return this.socketEventsInternal;
  }

  set socketEvents(events: any) {
    this.socketEventsInternal = events;
  }

}

export let APP_CONFIG: AppConfig;

@Injectable()
export class InitService {

  constructor(private http: HttpClient,
              private logService: LogService,
              private sentryService: SentryService) {
    APP_CONFIG = new AppConfig();
  }

  /**
   * Boot the init service - this gets called from an APP_INITIALIZER in app.module so that configuration can load
   * before the app is initialized. Static config from the back-end should load here
   */
  boot(): Promise<any> {
    return new Promise((resolve, reject) => {
      Observable.forkJoin(
        this.appConfig()
      ).subscribe(
        (result: any) => {
          APP_CONFIG.logglyToken = result[0].token;
          APP_CONFIG.socketEvents = result[0].socketEvents;
          // need to force initialize services since they don't have ngOnInit
          this.logService.init(result[0].token);
          this.sentryService.init(result[0].sentryDSN, result[0].envName);
          resolve();
        });
    });
  }


  appConfig() {
    return this.http
      .get(
        `/api/v1/config/appConfig`
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/init.service.ts